import React from 'react';
import { Page, Text, View, Document, StyleSheet, PDFDownloadLink, Image } from '@react-pdf/renderer';

// // Suponiendo que hayas capturado el gráfico y lo hayas guardado como 'bar-chart.png'
// import titleImage from "../../../../../../assets/images/report/report-title.png";
// import logo from "../../../../../../assets/images/report/Cooke_CL_Big-removebg-preview2.png";
// import barChartImage from "../../../../../../assets/images/report/bar-chart.png";

// Estilos para el documento
const styles = StyleSheet.create({
    page: {
        fontSize: 12,
        backgroundColor: '#ffffff',
    },
    coverPage: {
        position: 'relative',
        fontSize: 12,
        backgroundColor: '#ffffff',
        justifyContent: 'center',
        alignItems: 'center',
    },
    coverBackground: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        opacity: 0.9,
    },
    coverHeader: {
        marginTop: 10,
        marginRight: 10,
        textAlign: 'right',
        fontSize: 10,
        color: '#0c3c60',
    },
    titleContainer: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 150,
    },
    coverTitle: {
        fontSize: 40,
        color: '#ffffff',
        fontWeight: 'bold',
    },
    coverSubtitle: {
        fontSize: 20,
        color: '#ffffff',
        marginTop: 10,
    },
    coverFooter: {
        position: 'absolute',
        bottom: 20,
        left: 0,
        right: 0,
        backgroundColor: '#002855',
        padding: 10,
        textAlign: 'center',
        color: '#ffffff',
    },
    logo: {
        width: 100,
        height: 'auto',
        marginBottom: 10,
    },
    footerText: {
        fontSize: 12,
        color: '#ffffff',
    },
    indexPage: {
        padding: 30,
        backgroundColor: '#ffffff',
    },
    indexTitle: {
        fontSize: 24,
        marginBottom: 20,
        textAlign: 'center',
        color: '#3d3d3d',
    },
    indexItem: {
        marginBottom: 5,
        fontSize: 16,
    },
    sectionPage: {
        padding: 30,
        backgroundColor: '#ffffff',
    },
    sectionTitle: {
        fontSize: 30,
        marginBottom: 20,
        textAlign: 'center',
        color: '#0c3c60',
    },
    generalPage: {
        padding: 0,
        backgroundColor: '#ffffff',
    },
    generalHeader: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: 10,
        backgroundColor: '#ffffff',
        borderBottom: '1 solid #0c3c60',
    },
    generalHeaderText: {
        fontSize: 12,
        color: '#0c3c60',
    },
    pageNumber: {
        fontSize: 14,
        color: '#ffffff',
        backgroundColor: '#002855',
        borderRadius: '50%',
        width: 30,
        height: 30,
        textAlign: 'center',
        lineHeight: 1.8,
    },
    graphicContainer: {
        margin: 20,
        height: 200,
        justifyContent: 'center',
        alignItems: 'center',
    },
    graphicImage: {
        width: '100%',
        objectFit: 'cover',
    },
    footer: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: '#002855',
        height: 200, // Alto fijo de 200px
        textAlign: 'center',
        paddingTop: 20, // Espacio superior dentro del footer
        color: '#ffffff',
        justifyContent: 'center',
    },
    footerText: {
        fontSize: 14,
        color: '#ffffff',
    },
});

// Componente del documento PDF
const MyDocument = () => (
    <Document>
        <Page size="A4" style={styles.coverPage} orientation="landscape">
            <Image style={styles.coverBackground} src={titleImage} />
            <Text style={styles.coverHeader}>Report update: 08-08-2024 09:47</Text>
            <View style={styles.titleContainer}>
                <Text style={styles.coverTitle}>Monthly Report</Text>
                <Text style={styles.coverSubtitle}>August 2024</Text>
            </View>
            <View style={styles.coverFooter}>
                <Image style={styles.logo} src={logo} />
                <Text style={styles.footerText}>Ruta 226 km.8 El Tepual</Text>
                <Text style={styles.footerText}>Puerto Montt, Décima Región</Text>
                <Text style={styles.footerText}>https://cookeaqua.cl</Text>
            </View>
        </Page>

        <Page size="A4" style={styles.indexPage} orientation="landscape">
            <Text style={styles.indexTitle}>Índice</Text>
            <Text style={styles.indexItem}>1. Resumen Ejecutivo ..................................... 2</Text>
            <Text style={styles.indexItem}>2. Análisis de Actividades .............................. 3</Text>
            <Text style={styles.indexItem}>3. Gráficos y Datos ......................................... 4</Text>
            <Text style={styles.indexItem}>4. Conclusiones .............................................. 5</Text>
            <Text style={styles.paginator}>Página 1</Text>
        </Page>

        <Page size="A4" style={styles.sectionPage} orientation="landscape">
            <Text style={styles.sectionTitle}>1. Resumen Ejecutivo</Text>
            <Text style={styles.paginator}>Página 2</Text>
        </Page>

        <Page size="A4" style={styles.generalPage} orientation="landscape">
            <View style={styles.generalHeader}>
                <Text style={styles.generalHeaderText}>Aquí va el texto descriptivo de la página general</Text>
                <Text style={styles.pageNumber}>3</Text>
            </View>

            <View style={styles.graphicContainer}>
                <Image style={styles.graphicImage} src={barChartImage} />
            </View>

            <View style={styles.footer}>
                <Text style={styles.footerText}>Aquí va ir texto de la página general</Text>
            </View>
        </Page>
    </Document>
);

// Componente principal que ofrece el enlace de descarga
const PDFReport = () => (
    <div>
        <PDFDownloadLink document={<MyDocument />} fileName="reporte.pdf">
            {({ blob, url, loading, error }) =>
                loading ? 'Cargando documento...' : 'Descargar reporte'
            }
        </PDFDownloadLink>
    </div>
);

export default PDFReport;
